export default __webpack_public_path__ + "static/media/trophy-icon.b882a22e.svg";